import { useState } from "react";
import { CircleAlert, CircleCheck, Film, Image as ImageIcon, LoaderCircle, X } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { formatBytes } from "@/lib/format";

const Thumb = ({ item }) => {
  const [failed, setFailed] = useState(false);
  if (item.kind === "video" || failed) {
    const Icon = item.kind === "video" ? Film : ImageIcon;
    return (
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-slate-900 text-emerald-300">
        <Icon className="h-5 w-5" />
      </span>
    );
  }
  return <img src={item.previewUrl} alt="" onError={() => setFailed(true)} className="h-12 w-12 shrink-0 rounded-lg object-cover" />;
};

const StatusLine = ({ item, index }) => {
  if (item.status === "uploading") {
    return (
      <div className="mt-1.5 space-y-1" data-testid={`attachment-status-${index}`}>
        <Progress value={item.progress} className="h-1.5" />
        <p className="flex items-center gap-1 text-xs text-slate-500">
          <LoaderCircle className="h-3 w-3 animate-spin" /> Mengunggah... {item.progress}%
        </p>
      </div>
    );
  }
  if (item.status === "error") {
    return (
      <p className="mt-0.5 flex items-center gap-1 text-xs font-medium text-rose-600" data-testid={`attachment-status-${index}`}>
        <CircleAlert className="h-3.5 w-3.5" /> {item.error || "Gagal diunggah"}
      </p>
    );
  }
  return (
    <p className="mt-0.5 flex items-center gap-1 text-xs font-medium text-emerald-700" data-testid={`attachment-status-${index}`}>
      <CircleCheck className="h-3.5 w-3.5" /> Berhasil diunggah · {formatBytes(item.size)}
    </p>
  );
};

export const AttachmentItem = ({ item, index, onRemove }) => (
  <li className="fade-up flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-2.5" data-testid={`attachment-item-${index}`}>
    <Thumb item={item} />
    <div className="min-w-0 flex-1">
      <p className="truncate text-sm font-medium text-slate-800">{item.name}</p>
      <StatusLine item={item} index={index} />
    </div>
    <button
      type="button"
      onClick={onRemove}
      disabled={item.status === "uploading"}
      aria-label="Hapus lampiran"
      data-testid={`attachment-remove-btn-${index}`}
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-rose-50 hover:text-rose-600 disabled:opacity-40"
    >
      <X className="h-4 w-4" />
    </button>
  </li>
);
